import { isFeatureEnabled } from 'owa-feature-flags';
import { lazyShowOptOutDialog } from './lazy/index';
import { optIntoJsmvvmClientAndRedirect } from 'owa-optin/lib/utils/owaOptinUtility';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import store from './store';
import { action, mutator } from 'satcheljs';

export default createLegacyActionWithDatapoint('clientOptOut', { name: 'TnS_OptOut' })(
    function clientOptOut(modulePath?: string) {
        store.isClientOptedIn = false;
        if (isFeatureEnabled('usv-forum')) {
            lazyShowOptOutDialog.importAndExecute(cancelClientOptOut, modulePath);
        } else {
            optIntoJsmvvmClientAndRedirect(modulePath);
        }
    }
);

export const cancelClientOptOut = action('clientOptOut_cancel');

mutator(cancelClientOptOut, () => {
    store.isClientOptedIn = false;
});
